// services/tables.js
import { getSubdomain, fetchWithAuth } from "../helpers";
import { API_PASSWORD } from "../config";


export async function changeOrderStatus(orderId, status) {
  const subdomain = getSubdomain();
  const url = `https://${subdomain}.restocash.app/api/change/order/status/${status}/${orderId}?api_password=${API_PASSWORD}`;

  const token = localStorage.getItem("token"); // 👈 هات التوكن من localStorage

  const response = await fetch(url, {
    method: "GET", // لو الـ API محتاج POST بلغني ونعدّل
    headers: {
      Authorization: `Bearer ${token}`, // 👈 لازم علشان المصادقة
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const text = await response.text();
    console.error("❌ API Error:", text);
    throw new Error("فشل تغيير حالة الأوردر");
  }

  return await response.json();
}


export async function changeOrderStatusApi(orderId) {
  const subdomain = getSubdomain();
  const url = `https://${subdomain}.restocash.app/api/change/order/api/status/${orderId}?api_password=${API_PASSWORD}`;

  const token = localStorage.getItem("token"); // 👈 هات التوكن من localStorage

  const response = await fetch(url, {
    method: "GET", // لو الـ API محتاج POST بلغني ونعدّل
    headers: {
      Authorization: `Bearer ${token}`, // 👈 لازم علشان المصادقة
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const text = await response.text();
    console.error("❌ API Error:", text);
    throw new Error("فشل تغيير حالة الأوردر");
  }

  return await response.json();
}


export async function getDeliveryUserOrders() {
  const subdomain = getSubdomain();
  const url = `https://${subdomain}.restocash.app/api/get/delivery/user/orders?api_password=${API_PASSWORD}`;

  const token = localStorage.getItem("token");

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`, // 👈 مهم
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const text = await response.text();
    console.error("❌ API Error:", text);
    throw new Error("فشل جلب أوردرات الدليفري");
  }

  return await response.json();
}


export async function makeTableOrder(formData) {
  const subdomain = getSubdomain();
  const url = `https://${subdomain}.restocash.app/api/make/tables/order?api_password=${API_PASSWORD}`;

  const token = localStorage.getItem("token");

  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      // ⚠️ متحطش Content-Type هنا لأن FormData بيضيفه مع الـ boundary
    },
    body: formData, // ✨ ابعت الـ FormData زي ما هو
  });

  
  if (!response.ok) {
    // 👇 حاول نفك الرد كـ JSON (لو السيرفر بيرجع JSON للخطأ)
    let errorResponse;
    try {
      errorResponse = await response.json();
    } catch {
      errorResponse = await response.text();
    }

    console.error("❌ API Error:", errorResponse); // ✨ هيطبع نفس الشكل اللي انت عايزه
    throw new Error("فشل إنشاء الطلب");
  }

  return await response.json();
}


export async function checkTableByQr(qrcode) {
  const subdomain = getSubdomain();
  const url = `https://${subdomain}.restocash.app/api/check/table/by/qrcode/${qrcode}?api_password=${API_PASSWORD}`;

  const token = localStorage.getItem("token");

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    let errorResponse;
    try {
      errorResponse = await response.json();
    } catch {
      errorResponse = await response.text();
    }
    console.error("❌ API Error:", errorResponse);
    throw new Error("فشل التحقق من الطاولة عبر QR");
  }

  return await response.json();
}


